export const MARKUP_ICONS = [
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'treble-clef',
        name: 'Treble Clef'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'bass-clef',
        name: 'Bass Clef',
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'alto-clef',
        name: 'Alto Clef'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'flat',
        name: 'Flat'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'natural',
        name: 'Natural'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'sharp',
        name: 'Sharp'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'quarter-note-with-ledger-line',
        name: 'Quarter Note With Ledger Line'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'quarter-note-(without-stem)',
        name: 'Quarter Note (Without Stem)'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'quarter-note-upward-stem',
        name: 'Quarter Note Upward Stem'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'quarter-note-downward-stem',
        name: 'Quarter Note Downward Stem'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'half-note-upward-stem',
        name: 'Half Note Upward Stem'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'half-note-downward-stem',
        name: 'Half Note Downward Stem'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'whole-note',
        name: 'Whole Note'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'dotted-quarter-note',
        name: 'Dotted Quarter Note'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'eighth-note-upward-stem',
        name: 'Eighth Note Upward Stem'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'eighth-note-downward-stem',
        name: 'Eighth Note Downward Stem'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: '16th-note-upward-stem',
        name: '16th Note Upward Stem'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: '16th-note-downward-stem',
        name: '16th Note Downward Stem'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'rhythm-dot',
        name: 'Rhythm Dot'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'ledger-line',
        name: 'Ledger Line'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'quarter-rest',
        name: 'Quarter Rest'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'eighth-rest',
        name: 'Eighth Rest'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'half-rest',
        name: 'Half Rest'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'whole-rest',
        name: 'Whole Rest'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'multi-rest',
        name: 'Multi Rest'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: '16th-note-rest',
        name: '16th Note Rest'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'tied-8th-note-1',
        name: 'Tied Eighth Note 1'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'tied-8th-note-2',
        name: 'Tied Eighth Note 2'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'tied-8th-note-3',
        name: 'Tied Eighth Note 3'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'tied-16th-note-1',
        name: 'Tied 16th Note 1'
    },
    {
        type: 'music-symbol',
        category: 'notation',
        key: 'tied-16th-note-2',
        name: 'Tied 16th Note 2'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'g_em',
        name: 'G/Em'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'd_bm',
        name: 'D/Bm'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'a_f%23m',
        name: 'A/F#M'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'e_c%23m',
        name: 'E/C#M'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'b_g%23m',
        name: 'B/G#M'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'f%23_d%23m',
        name: 'F#/D#M'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'c%23_a%23m',
        name: 'C#/A#M'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'f_dm',
        name: 'F/Dm'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'bb_gm',
        name: 'Bb/Gm'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'eb_cm',
        name: 'Eb/Cm'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'ab_fm',
        name: 'Ab/Fm'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'db_bbm',
        name: 'Db/Bbm'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'gb_ebm',
        name: 'Gb/Ebm'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'cb_abm',
        name: 'Cb/Abm'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '2_2',
        name: '2/2'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '2_4',
        name: '2/4'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '3_4',
        name: '3/4'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '4_4',
        name: '4/4'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '5_4',
        name: '5/4'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '3_8',
        name: '3/8'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '6_8',
        name: '6/8'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '12_8',
        name: '12/8'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '5_8',
        name: '5/8'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '7_8',
        name: '7/8'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'barline',
        name: 'Barline'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'start-repeat',
        name: 'Start Repeat'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'end-repeat',
        name: 'End Repeat'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'final-barline',
        name: 'Final Barline'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'double-barline',
        name: 'Double Barline'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'volta-1',
        name: 'Volta 1'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'volta-2',
        name: 'Volta 2'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'segno-1',
        name: 'Segno 1'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'segno-2',
        name: 'Segno 2'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'coda-symbol',
        name: 'Coda Symbol'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'coda',
        name: 'Coda'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'to-coda',
        name: 'To Coda'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'fine',
        name: 'Fine'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'to-fine',
        name: 'To Fine'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'fermata',
        name: 'Fermata'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: 'simile',
        name: 'Simile'
    },
    {
        type: 'music-symbol',
        category: 'graphics',
        key: '2-bar-simile',
        name: '2 Bar Simile'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'mezzo-forte',
        name: 'Mezzo Forte'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'forte',
        name: 'Forte'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'fortissimo',
        name: 'Fortissimo'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'fortississimo',
        name: 'Fortississimo'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'mezzo-piano',
        name: 'Mezzo Piano'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'piano',
        name: 'Piano'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'pianissimo',
        name: 'Pianissimo'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'pianississimo',
        name: 'Pianississimo'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'più',
        name: 'Più'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'crescendo',
        name: 'Crescendo'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'diminuendo',
        name: 'Diminuendo'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'wave-glissando',
        name: 'Wave Glissando'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'glissando',
        name: 'Glissando'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'trill',
        name: 'Trill'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'up-bow',
        name: 'Up Bow'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'down-bow',
        name: 'Down Bow'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'marcato',
        name: 'Marcato'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'tenuto',
        name: 'Tenuto'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'staccato',
        name: 'Staccato'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'staccatissimo',
        name: 'Staccatissimo'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'slur',
        name: 'Slur'
    },
    {
        type: 'music-symbol',
        category: 'expression-and-technique',
        key: 'tremolo',
        name: 'Tremolo'
    },
    {
        type: 'music-symbol',
        category: 'piano',
        key: 'left-hand',
        name: 'Left Hand'
    },
    {
        type: 'music-symbol',
        category: 'piano',
        key: 'right-hand',
        name: 'Right Hand'
    },
    {
        type: 'music-symbol',
        category: 'piano',
        key: 'pedal',
        name: 'Pedal'
    },
    {
        type: 'music-symbol',
        category: 'piano',
        key: 'dashed-line',
        name: 'Dashed Line'
    },
    {
        type: 'music-symbol',
        category: 'piano',
        key: 'pedal-lyft',
        name: 'Pedal Lyft'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'a',
        name: 'A'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'am',
        name: 'Am'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'b',
        name: 'B'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'bm',
        name: 'Bm'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'c',
        name: 'C'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'cm',
        name: 'Cm'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'd',
        name: 'D'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'dm',
        name: 'Dm'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'e',
        name: 'E'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'em',
        name: 'Em'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'f',
        name: 'F'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'fm',
        name: 'Fm'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'g',
        name: 'G'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'gm',
        name: 'Gm'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'empty-chord-chart',
        name: 'Empty Chord Chart'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'pulgar',
        name: 'Pulgar'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'indice',
        name: 'Indice'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'medio',
        name: 'Medio'
    },
    {
        type: 'music-symbol',
        category: 'guitar',
        key: 'anular',
        name: 'Anular'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'regular-note-upward',
        name: 'Regular Note Upward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'bracket-accidental-upward',
        name: 'Bracket Accidental Upward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'x-note-upward',
        name: 'X Note Upward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'x-half-note-upward',
        name: 'X Half Note Upward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'x-note-with-ledger-line-upward',
        name: 'X Note With Ledger Line Upward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'x-note-above-ledger-line-upward',
        name: 'X Note Above Ledger Line Upward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'percussion-clef',
        name: 'Percussion Clef'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'regular-note-downward',
        name: 'Regular Note Downward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'bracket-accidental-downward',
        name: 'Bracket Accidental Downward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'x-note-downward',
        name: 'X Note Downward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'x-half-note-downward',
        name: 'X Half Note Downward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'x-note-with-ledger-line-downward',
        name: 'X Note With Ledger Line Downward'
    },
    {
        type: 'music-symbol',
        category: 'drum-set',
        key: 'x-note-above-ledger-line-downward',
        name: 'X Note Above Ledger Line Downward'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'ab',
        name: 'Ab'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'a',
        name: 'A'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'a%23',
        name: 'A#'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'bb',
        name: 'Bb'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'b',
        name: 'B'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'b%23',
        name: 'B#'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'c',
        name: 'C'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'cb',
        name: 'Cb'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'c%23',
        name: 'C#'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'db',
        name: 'Db'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'd',
        name: 'D'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'd%23',
        name: 'D#'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'eb',
        name: 'Eb'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'e',
        name: 'E'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'e%23',
        name: 'E#'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'fb',
        name: 'Fb'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'f',
        name: 'F'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'f%23',
        name: 'F#'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'gb',
        name: 'Gb'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'g',
        name: 'G'
    },
    {
        type: 'notation-text',
        category: 'chord-note-names',
        key: 'g%23',
        name: 'G#'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'do',
        name: 'Do'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'dob',
        name: 'Dob'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'do%23',
        name: 'Do#'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 're',
        name: 'Re'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'reb',
        name: 'Reb'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 're%23',
        name: 'Re#'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'mi',
        name: 'Mi'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'mib',
        name: 'Mib'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'mi%23',
        name: 'Mi#'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'fa',
        name: 'Fa'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'fab',
        name: 'Fab'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'fa%23',
        name: 'Fa#'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'sol',
        name: 'Sol'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'solb',
        name: 'Solb'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'sol%23',
        name: 'Sol#'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'la',
        name: 'La'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'lab',
        name: 'Lab'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'la%23',
        name: 'La#'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'ti',
        name: 'Ti'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'tib',
        name: 'Tib'
    },
    {
        type: 'notation-text',
        category: 'solfege-names',
        key: 'ti%23',
        name: 'Ti#'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: 'sus4',
        name: 'Sus4'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '5',
        name: '5'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '6',
        name: '6'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '7',
        name: '7'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: 'm7',
        name: 'M7'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: 'maj7',
        name: 'Maj7'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: 'b9',
        name: 'B9'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '9',
        name: '9'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '%23_9',
        name: '#9'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '11',
        name: '11'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '13',
        name: '13'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '7_9',
        name: '7/9'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: '7b5',
        name: '7B5'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: 'augmented',
        name: 'Augmented'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: 'diminished',
        name: 'Diminished'
    },
    {
        type: 'notation-text',
        category: 'chord-tensions',
        key: 'half-diminished',
        name: 'Half Diminished'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: '1',
        name: '1'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: '2',
        name: '2'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: '3',
        name: '3'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: '4',
        name: '4'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: '5',
        name: '5'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: '6',
        name: '6'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: '7',
        name: '7'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: 'inversions-6',
        name: 'Inversions 6'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: 'inversions-6-4',
        name: 'Inversions 6 4'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: 'inversions-7',
        name: 'Inversions 7'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: 'inversions-6-5',
        name: 'Inversions 6 5'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: 'inversions-4-3',
        name: 'Inversions 4 3'
    },
    {
        type: 'notation-text',
        category: 'tonal-degree',
        key: 'inversions-4-2',
        name: 'Inversions 4 2'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'good-work',
        name: 'Good Work',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'good-job',
        name: 'Good Job',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'great-job',
        name: 'Great Job',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'perfect-job',
        name: 'Perfect Job',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'high-five',
        name: 'High Five',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'good-luck',
        name: 'Good Luck',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'fantastic',
        name: 'Fantastic',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'the-best',
        name: 'The Best',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'excellent',
        name: 'Excellent',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'brilliant',
        name: 'Brilliant',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'congrats-you-are-the-best',
        name: 'Congrats You Are The Best',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'you-are-the-best',
        name: 'You Are The Best',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'shine-on',
        name: 'Shine On',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'ok',
        name: 'Ok',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'motivation',
        key: 'yes',
        name: 'Yes',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'awards',
        key: 'crown',
        name: 'Crown',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'awards',
        key: 'trophy',
        name: 'Trophy',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'awards',
        key: 'shield',
        name: 'Shield',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'awards',
        key: 'medal',
        name: 'Medal',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'awards',
        key: 'flag',
        name: 'Flag',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'awards',
        key: 'gift',
        name: 'Gift',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'icons',
        key: 'rainbow',
        name: 'Rainbow',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'icons',
        key: 'thumbs-up',
        name: 'Thumbs Up',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'icons',
        key: 'smiley',
        name: 'Smiley',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'icons',
        key: 'eye',
        name: 'Eye',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'icons',
        key: 'flower',
        name: 'Flower',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'icons',
        key: 'heart',
        name: 'Heart',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'do-good-work',
        name: 'Do Good Work',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'good-luck',
        name: 'Good Luck',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'you-can',
        name: 'You Can',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'stay-positive',
        name: 'Stay Positive',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'be-happy',
        name: 'Be Happy',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'dream-big',
        name: 'Dream Big',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'work-hard',
        name: 'Work Hard',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'make-it-happen',
        name: 'Make It Happen',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'everything-is-possible',
        name: 'Everything Is Possible',
        disableModifying: 'true'
    },
    {
        type: 'stickers',
        category: 'badges',
        key: 'thank-you',
        name: 'Thank You',
        disableModifying: 'true'
    }
];